import { Controller } from "stimulus";
import parkedService from "./parked_service";
import loader from "../../assets/loader";

export default class extends Controller {

    static targets = ['icon'];

    connect() {
        if (this.element.dataset.action.match(/#add\b/)) {
            this.update = this.update_add;
        } else if (this.element.dataset.action.match(/#remove\b/)) {
            this.update = this.update_remove;
        } else if (this.element.dataset.action.match(/#toggle\b/)) {
            this.update = this.update_toggle;
        }

        parkedService.ready.then(() => this.update());
        parkedService.on("update", () => this.update());
        this.loading_icon = document.createElement('span');
        this.loading_icon.classList.add('far', 'fa-spinner', 'fa-spin');
    }

    update_add() {
        if (parkedService.isMachineParked(this.machine_id)) {
            this.element.classList.add("hidden");
        } else {
            this.element.classList.remove("hidden");
        }
    }

    update_remove() {
        if (parkedService.isMachineParked(this.machine_id)) {
            this.element.classList.remove("hidden");
        } else {
            this.element.classList.add("hidden");
        }
    }

    update_toggle() {
        let defaultClasses = this.element.dataset.classDefault.split(/\s+/);
        let parkedClasses = this.element.dataset.classParked.split(/\s+/);
        let elem = this.hasIconTarget ? this.iconTarget : this.element;
        if (parkedService.isMachineParked(this.machine_id)) {
            elem.classList.remove(...defaultClasses);
            elem.classList.add(...parkedClasses);
        } else {
            elem.classList.remove(...parkedClasses);
            elem.classList.add(...defaultClasses);
        }
    }

    get machine_id() {
        return this.element.dataset.machineId;
    }

    add(event) {
        event.preventDefault();
        if (this.hasIconTarget) {
            this.iconTarget.classList.add('hidden');
            this.iconTarget.after(this.loading_icon);
        } else {
            loader.show();
        }
        parkedService.addMachineId(this.machine_id)
            .catch(() => { })
            .then(() => {
                if (this.hasIconTarget) {
                    this.iconTarget.classList.remove('hidden');
                    this.loading_icon.remove();
                } else {
                    loader.hide()
                }
            });
    }

    remove(event) {
        event.preventDefault();
        if (this.hasIconTarget) {
            this.iconTarget.classList.add('hidden');
            this.iconTarget.after(this.loading_icon);
        } else {
            loader.show();
        }
        let row = document.getElementById(`park_${this.machine_id}`);
        parkedService.removeMachineId(this.machine_id)
            .then(() => {
                if (row) {
                    row.remove();
                }
            })
            .catch(() => { })
            .then(() => {
                if (this.hasIconTarget) {
                    this.iconTarget.classList.remove('hidden');
                    this.loading_icon.remove();
                } else {
                    loader.hide()
                }
            });
    }

    toggle(event) {
        if (parkedService.isMachineParked(this.machine_id)) {
            this.remove(event);
        } else {
            this.add(event);
        }
    }
}
